// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import SearchFieldWrapper, { SearchFieldWrapperStyles } from "@steiner/App/Components/ReorderPad/SearchFieldWrapper";
import Select, { SelectPresentationProps, SelectProps } from "@steiner/MobiusOverrides/Select/Select";
import React, { FC } from "react";

export interface SearchFieldSelectSortTypeProps {
    selectProps?: SelectProps;
    options?: { value: string; label: string }[];
    extendedStyles?: SearchFieldSelectSortTypeStyles;
}

export interface SearchFieldSelectSortTypeStyles {
    searchFieldWrapperStyles?: SearchFieldWrapperStyles;
    select?: SelectPresentationProps;
}

export const searchFieldSelectSortTypeStyles: SearchFieldSelectSortTypeStyles = {};

const SearchFieldSelectSortType: FC<SearchFieldSelectSortTypeProps> = React.memo(
    ({ options, extendedStyles, selectProps }) => {
        const [styles] = React.useState(() => mergeToNew(searchFieldSelectSortTypeStyles, extendedStyles));

        return (
            <SearchFieldWrapper {...styles.searchFieldWrapperStyles}>
                <Select {...selectProps} {...styles.select}>
                    <option value="" disabled>
                        {translate("Select an option")}
                    </option>
                    {options?.map(sortType => (
                        <option key={sortType.value} value={sortType.value}>
                            {sortType.label}
                        </option>
                    ))}
                </Select>
            </SearchFieldWrapper>
        );
    },
);

export default SearchFieldSelectSortType;
